export default __webpack_public_path__ + "static/media/fondo.eb0c8f78.jpg";